/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7282a8fc2b3913686af91d8f596388>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "FieldDropdown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-dropdown
 * Usage guidance:
 * Known uses: Dropdown field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const FieldDropdownIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "FieldDropdownIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 3.5H0V2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M9 8.19 7.03 6.22 5.97 7.28l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5-1.06-1.06z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
FieldDropdownIcon.displayName = 'FieldDropdownIcon';
var _default = exports.default = FieldDropdownIcon;